exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".model-modal__spacer[data-v-6116356d]{margin:30px 0}#modal_model_details .public-project-container[data-v-6116356d]{box-shadow:none;padding:0 15px;width:100%}.model-availability[data-v-6116356d]{padding-top:15px!important}@media (max-width:768px){.model-availability[data-v-6116356d]{padding:0 10px}}#modelDetails .public-project-container .project-contact[data-v-6116356d]{margin:0}.model-modal__description[data-v-6116356d]{max-height:325px}.model-modal__description--active[data-v-6116356d]{max-height:none}", ""]);

// exports
